import { Moment } from 'moment';
import { RunStatusFilterOptions, UnassignedFilterOptions } from '@bringg/types';
import { DateRangeKeyword } from '@bringg/react-components';

export type InitialFilterBarObject = Omit<FiltersObject, DateRangeFieldKeys> & {
	timeWindow?: DateRangeFilterBarValue;
	slaWindow?: DateRangeFilterBarValue;
	reservedUntil?: DateRangeFilterBarValue;
};

export type DateRangeFieldKeys =
	| FilterBarListItemKeys.TIME_WINDOW
	| FilterBarListItemKeys.SLA
	| FilterBarListItemKeys.RESERVED_UNTIL;
export type DateRangeFilterBarValue = [Moment, Moment] | [DateRangeKeyword, DateRangeKeyword];

export enum FilterBarListItemKeys {
	TEAMS = 'selectedTeams',
	DRIVERS = 'selectedUsers',
	TIME_WINDOW = 'timeWindow',
	UNASSIGNED = 'unassigned',
	TAGS = 'selectedTags',
	RANKS = 'ranks',
	SKILLS = 'skills',
	FLEETS = 'fleets',
	ROUTES = 'selectedRuns',
	SERVICE_PLANS = 'servicePlans',
	SLA = 'sla',
	UNSCHEDULED = 'unscheduled',
	RESERVED_UNTIL = 'reservedUntil',
	TASKS = 'selectedTasks',

	//runs filters
	STATUS = 'runStatus',
	RUN_TIME_WINDOW = 'runTimeWindow',
	PLANNED_ROUTE = 'plannedRouteIds'
}

export type TaskFiltersObject = {
	[FilterBarListItemKeys.TEAMS]?: number[];
	[FilterBarListItemKeys.DRIVERS]?: number[];
	[FilterBarListItemKeys.UNASSIGNED]?: UnassignedFilterOptions;
	[FilterBarListItemKeys.TAGS]?: number[];
	[FilterBarListItemKeys.RANKS]?: number[];
	[FilterBarListItemKeys.SKILLS]?: string[];
	[FilterBarListItemKeys.FLEETS]?: number[];
	[FilterBarListItemKeys.ROUTES]?: (number | null)[];
	[FilterBarListItemKeys.SERVICE_PLANS]?: number[];
	[FilterBarListItemKeys.UNSCHEDULED]?: number;
	[FilterBarListItemKeys.TIME_WINDOW]?: [string, string];
	[FilterBarListItemKeys.SLA]?: [string, string];
	[FilterBarListItemKeys.RESERVED_UNTIL]?: [string, string];
	[FilterBarListItemKeys.TASKS]?: number[];
};

export type RunFiltersObject = {
	[FilterBarListItemKeys.TEAMS]?: number[];
	[FilterBarListItemKeys.DRIVERS]?: number[];
	[FilterBarListItemKeys.ROUTES]?: (number | null)[];
	[FilterBarListItemKeys.STATUS]?: RunStatusFilterOptions;
	[FilterBarListItemKeys.RUN_TIME_WINDOW]?: string;
	[FilterBarListItemKeys.PLANNED_ROUTE]?: number[];
};

export type FiltersObject = TaskFiltersObject & RunFiltersObject;

export const supportedTaskFiltersList: (keyof FiltersObject)[] = [
	FilterBarListItemKeys.DRIVERS,
	FilterBarListItemKeys.UNASSIGNED,
	FilterBarListItemKeys.TAGS,
	FilterBarListItemKeys.RANKS,
	FilterBarListItemKeys.SKILLS,
	FilterBarListItemKeys.FLEETS,
	FilterBarListItemKeys.ROUTES,
	FilterBarListItemKeys.SERVICE_PLANS,
	FilterBarListItemKeys.UNSCHEDULED,
	FilterBarListItemKeys.TIME_WINDOW,
	FilterBarListItemKeys.SLA,
	FilterBarListItemKeys.RESERVED_UNTIL,
	FilterBarListItemKeys.TASKS
];

export const supportedRoutesFiltersList: (keyof FiltersObject)[] = [
	FilterBarListItemKeys.RUN_TIME_WINDOW,
	FilterBarListItemKeys.PLANNED_ROUTE,
	FilterBarListItemKeys.STATUS,
	FilterBarListItemKeys.TEAMS
];

export const supportedFiltersList: (keyof FiltersObject)[] = [
	...supportedTaskFiltersList,
	...supportedRoutesFiltersList
];

//todo - remove it once supporting all tasks filters
export const supportedRunsMonitoringScreenList: (keyof FiltersObject)[] = [
	FilterBarListItemKeys.ROUTES,
	...supportedRoutesFiltersList,
	FilterBarListItemKeys.TASKS,
	FilterBarListItemKeys.DRIVERS
];
